<template>
  <div class="root">
    <div class="head clearfix">
      <Checkbox
        size="small"
        class="checkbox"
        :value="items.length > 0 && items.every(i => i.selected)"
        :indeterminate="selectedItem.length > 0 && !items.every(i => i.selected)"
        @on-change="handleSelectAllItem"
      />
      <h4>
        {{ parentMaterialGroup.material_type.name }}
        <span class="sub">
          (残り: {{ remainingCapacity(parentMaterialGroup, items) }})
        </span>
        <span v-if="parentMaterialGroup.material_type.id == 'announce'">
          <Poptip placement="right-start" width="450">
            <Icon type="ios-information-circle" />
            <div slot="content" style="font-size: 0.75em">
              <div style="height: 150px">
                <p>「ABEMA告知」で設定した文言は、L字縦文言の左のスペースに表示されます。</p>
                <p>例1) 大雨の最新情報はABEMA NEWSで配信中</p>
                <p>例2) 台風99号の最新情報はABEMA NEWSで配信中</p>
                <p>ABEMA NEWSの文言は、自動で囲み表示になります。</p>
                <p>※編集更新すると、L字0A中は即時文言がOAされます</p>
                <p>※ABEMA告知を表示しない場合は、素材一覧から削除してください。</p>
              </div>
            </div>
          </Poptip>
        </span>
      </h4>
      <div class="action" v-if="isWritable">
        <template v-if="!workspace.onair || (!workspace.config.safe_material_types || (!!workspace.config.safe_material_types && workspace.config.safe_material_types.includes(parentMaterialGroup.material_type.id))) || items.length > 1">
          <div v-if="selectedItem.length > 0 && selectedItem.length < items.length && items.length > 1" style="text-align: center; display: inline-block; flex: 1;">
          <a class="black" @click="moveupSelectedItem"><Icon type="md-arrow-up" />上へ移動</a>
          <a class="black" @click="movedownSelectedItem"><Icon type="md-arrow-down" />下へ移動</a>
          </div>

          <a v-if="selectedItem.length > 0 && (!workspace.onair || (!workspace.config.safe_material_types || (!!workspace.config.safe_material_types && workspace.config.safe_material_types.includes(parentMaterialGroup.material_type.id))) || items.length > 1 && selectedItem.length < items.length && visibleItem.length > 1)" class="red" @click="deleteSelectedItem"><Icon type="md-trash" />削除</a>
          <a v-if="selectedItem.length > 0 && (!!workspace.config.safe_material_types && workspace.config.safe_material_types.includes(parentMaterialGroup.material_type.id) || selectedItem.length < visibleItem.length)" class="black" @click="hideSelectedItem"><Icon type="md-eye-off" />非表示</a>
          <a v-if="selectedItem.length > 0" class="black" @click="showSelectedItem"><Icon type="md-eye" />表示</a>
        </template>
        <a class="blue"
        v-if="isWritable && selectedItem.length == 0 && items.length < parentMaterialGroup.material_type.capacity"
         @click="addFixedJournals(parentMaterialGroup, items)"
        >
          <Icon type="md-folder-open" />
          定型文を追加
        </a>
        <template v-if="parentMaterialGroup.material_type.id == 'announce'">
          <a
            class="blue"
            v-if="isWritable && selectedItem.length == 0 && items.length < parentMaterialGroup.material_type.capacity"
            @click="announceModal.show = true"
          >
            <Icon type="md-add" />
            原稿を追加
          </a>
        </template>
        <template v-else>
          <a
            class="blue"
            v-if="isWritable && selectedItem.length == 0 && items.length < parentMaterialGroup.material_type.capacity"
            @click="createModal.show = true"
          >
            <Icon type="md-add" />
            原稿を追加
          </a>
        </template>
      </div>
    </div>
    <div class="content">
      <draggable
        v-model="items"
        v-bind="handleDragItem"
        :disabled="!(!!workspace.config.sortable && isWritable)"
        @change="updateMaterialOrder"
        @start="startMoveMaterial"
        @end="endMoveMaterial"
        :force-fallback="true" :scroll-sensitivity="200"
        >
        <transition-group type="transition" name="list">
          <div v-for="row in items" :key="row.id" :class="['item', 'clearfix', {'item-sortable': !!workspace.config.sortable && isWritable, 'item-sortable-locked': sortableLock !== null && sortableLock != parentMaterialGroup.id}]" :data-material-id="row.id">
            <Checkbox size="small" class="checkbox" v-model="row.selected" />
            <p :class="['text', {'hide': row.hidden}]">
              <Tooltip
                v-if="row.accepted_lifetime && row.accepted_lifetime.expired"
                :content="`採用から${row.accepted_lifetime.lifetime_minutes}分以上経過しています。情報が古い可能性があります。`"
                placement="top-start"
                :max-width="280"
                transfer
              >
                <Icon type="md-alert" class="expired-icon" />
              </Tooltip>
              {{ row.journal.text }}
            </p>
            <div class="action" v-if="isWritable">
              <a
                v-if="!!row.journal.meta.ref"
                :href="row.journal.meta.ref"
                target="_blank"
                >
                <Icon type="ios-undo"></Icon>
                <template v-if="row.journal.meta.ref.includes('transit.yahoo.co.jp')">参考サイト</template>
                <template v-else>公式サイト</template>
              </a>
              {{  }}
              <a class="blue" @click="showAnnounceModal(row.journal)" v-if="parentMaterialGroup.material_type.id == 'announce'"><Icon type="md-create" />編集</a>
              <a class="blue" @click="setJournalEditModalTarget(row.journal)" v-else><Icon type="md-create" />編集</a>
              <template v-if="!workspace.onair || (!workspace.config.safe_material_types || (!!workspace.config.safe_material_types && workspace.config.safe_material_types.includes(parentMaterialGroup.material_type.id))) || items.length > 1">
                <a v-if="row.hidden" class="black" @click="showMaterial(row.id)" style="display: inline-block; width: 46px;"><Icon type="md-eye" />表示</a>
		<a v-else-if="!!workspace.config.safe_material_types && workspace.config.safe_material_types.includes(parentMaterialGroup.material_type.id) || visibleItem.length > 1" class="gray" @click="hideMaterial(row.id)" style="display: inline-block; width: 46px;"><Icon type="md-eye-off" />非表示</a>
    <a v-if="!workspace.onair || (!!workspace.config.safe_material_types && workspace.config.safe_material_types.includes(parentMaterialGroup.material_type.id) || visibleItem.length > 1)" class="red" @click="deleteModal.show = true; deleteModal.data.items = [row]"><Icon type="md-trash" />削除</a>
              </template>
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
    <Modal
      :closable="false"
      footer-hide
      v-model="createModal.show"
    >
      <div>
        <Row
          >
          <Col span="24">
            <Input
              v-model="createModal.data.journal_text"
              type="textarea"
              :autosize="{minRows: 4,maxRows: 8}"
              placeholder="原稿を入力..." />
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <span
              :class="{'red': createModal.data.journal_text > 26}"
              style="float: right;"
              >
              {{ createModal.data.journal_text.length }}文字
            </span>
          </Col>
        </Row>
        <Row style="margin: 24px 0 0">
          <Col span=24>
            <Button type="text" @click="createModal.show = false">キャンセル</Button>
            <Button
              type="primary" style="float: right" @click="createMaterial"
              :disabled="createModal.data.journal_text && (createModal.data.journal_text.length != createModal.data.journal_text.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g).length)"
            >追加する</Button>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal :closable="false" footer-hide v-model="announceModal.show">
      <div>
        <Row
          >
          <Col span="24">
            <Input
              v-model="announceModal.data.journal_text"
              :autosize="{minRows: 4,maxRows: 8}"
              placeholder="原稿を入力..."
            >
              <span slot="append">ABEMA NEWSで配信中</span>
            </Input>
          </Col>
        </Row>
        <Row style="padding: 1em 0">
          <Col span="24">
          <p style="font-size: 0.85em">
            <span style="font-weight:bold">原稿の後に「ABEMA NEWSで配信中」が自動で追記されます。</span>
            <br />
            <br />
            <br />
            例1) 大雨の最新情報は（ABEMA NEWSで配信中）
            <br />
            例2) 台風99号の最新情報は（ABEMA NEWSで配信中）
            <br />
            <br />
            ※ 編集更新すると、L字0A中は即時文言がOAされます
            <br />
            ※ ABEMA告知を表示しない場合は、連携停止の後に素材一覧から削除してください。
          </p>
          </Col>
        </Row>
        <Row style="margin: 24px 0 0">
          <Col span=24 style="clearfix">
            <Button type="text" @click="announceModal.show = false">キャンセル</Button>
            <Button style="float: right" v-if="!announceModal.data.journal_id" @click="createAnnounceMaterial" :disabled="!announceModal.data.journal_text">設定する</Button>
            <Button style="float: right" v-else @click="updateAnnounceMaterial" :disabled="!announceModal.data.journal_text">設定する</Button>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal
      :closable="false"
      footer-hide
      v-model="deleteModal.show"
    >
      <div>
        <Row>
          <Col span="24">
            <p style="padding: 1em 1em 3em; font-weight: bold; vertical-align: middle; font-size: 15px; line-height: 24px">
              <Icon type="md-information-circle" size="24" />
              以下の素材が削除されます。よろしいですか？
            </p>
            <p style="padding: 0px 3em 6px" v-for="i in deleteModal.data.items">
              {{ i.journal.text }}
            </p>
          </Col>
        </Row>
        <Row style="margin: 24px 0 0">
          <Col span=24>
            <Button type="text" @click="deleteModal.show = false">キャンセル</Button>
            <Button type="primary" style="float: right" @click="deleteMaterial(deleteModal.data.items.map(i => i.id)); deleteModal.show = false">削除する</Button>
          </Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'

export default {
  props: ['parentMaterialList', 'parentMaterialGroup', 'workspace', 'isWritable', 'sortableLock', 'setSortableLock'],
  components: { draggable },
  data() {
    return {
      items: [],
      createModal: {
        show: false,
        data: {journal_id: "", journal_text: ""}
      },
      deleteModal: {
        show: false,
        data: {items: []}
      },
      announceModal: {
        show: false,
        data: {journal_text: ""}
      }
    }
  },
  methods: {
    ...mapActions({
      setJournalEditModalTarget: 'dashboard/setJournalEditModalTarget',
      setFixedJournalAcceptModalTarget: 'fixedJournals/setFixedJournalAcceptModalTarget',
    }),
    remainingCapacity(parentMaterialGroup, items) {
      return parentMaterialGroup.material_type.capacity - items.length
    },
    addFixedJournals(materialGroup, items) {
      const remainingCapacity = this.remainingCapacity(materialGroup, items)
      this.setFixedJournalAcceptModalTarget({materialGroup, remainingCapacity})
    },
    updateMaterialOrder() {
      this.$store.dispatch('batchUpdateMaterial', {
        ...this.$route.params,
        data: this.items.map((el, idx) => {
          return {
            id: el.id,
            order: idx + 1
          }
        })
      })
    },
    startMoveMaterial(e) {
      this.disableSelection();
      this.setSortableLock(this.parentMaterialGroup.id)
    },
    endMoveMaterial(e) {
      this.enableSelection();
      this.setSortableLock(null)
    },
    createMaterial() {
      this.$store.dispatch(
        'createMaterial', {
        ...this.$route.params,
          materialInput: {
            material_group_id: this.parentMaterialGroup.id,
            order: null,
            journal: {
              text: this.createModal.data.journal_text,
              meta: {}
            }
          }
        }
      ).then(() => {
        this.createModal.show = false
        this.createModal.data.journal_text = ""
      })
    },
    createAnnounceMaterial() {
      this.$store.dispatch(
        'createMaterial', {
          ...this.$route.params,
          materialInput: {
            material_group_id: this.parentMaterialGroup.id,
            order: null,
            journal: {
              text: this.announceModal.data.journal_text + "ABEMA NEWSで配信中",
              meta: {}
            }
          }
        }
      ).then(() => {
        this.announceModal.show = false
        this.announceModal.data.journal_text = ""
      })
    },
    updateAnnounceMaterial() {
      this.$store.dispatch(
        'updateJournal', {
          ...this.$route.params,
          journal: {
            id: this.announceModal.data.journal_id,
            text: this.announceModal.data.journal_text + "ABEMA NEWSで配信中",
            meta: {}
          }
        }
      ).then(() => {
        this.announceModal.show = false
        this.announceModal.data.journal_id = ""
        this.announceModal.data.journal_text = ""
      })
    },
    showAnnounceModal(journal) {
      this.announceModal.data.journal_id = journal.id
      this.announceModal.data.journal_text = journal.text.replace("ABEMA NEWSで配信中", "")
      this.announceModal.show = true
    },
    async hideSelectedItem() {
      for (const i of this.selectedItem) {
        await this.$store.dispatch('hideMaterial', {...this.$route.params, materialId: i.id})
      }
    },
    async showSelectedItem() {
      for (const i of this.selectedItem) {
        await this.$store.dispatch('showMaterial', {...this.$route.params, materialId: i.id})
      }
    },
    async moveupSelectedItem() {
      // 進行方向 上 (-1)
      var offset = -1
      for (const i of this.selectedItem) {
        var idx = this.items.indexOf(i)

        // すでに上端 or 上部アイテムがselectedItem なら移動しない
        if (idx == 0 || this.selectedItem.includes(this.items[idx + offset])) {
          continue
        }
        [this.items[idx + offset], this.items[idx]] = [this.items[idx], this.items[idx + offset]]
      }
      await this.updateMaterialOrder()
    },
    async movedownSelectedItem() {
      // 進行方向 下 (+1)
      var offset = 1
      for (const i of this.selectedItem.reverse()) {
        var idx = this.items.indexOf(i)

        // すでに下端 or 下部アイテムがselectedItem なら移動しない
        if (idx ==  this.items.length - 1 || this.selectedItem.includes(this.items[idx + offset])) {
          continue
        }
        [this.items[idx + offset], this.items[idx]] = [this.items[idx], this.items[idx + offset]]
      }
      await this.updateMaterialOrder()
    },
    async deleteSelectedItem() {
      this.deleteModal.show = true
      this.deleteModal.data.items = this.items.filter(i => i.selected)
    },
    async hideMaterial(materialId) {
      await this.$store.dispatch('hideMaterial', {...this.$route.params, materialId})
    },
    async showMaterial(materialId) {
      await this.$store.dispatch('showMaterial', {...this.$route.params, materialId})
    },
    async deleteMaterial(materialIds) {
      for (const materialId of materialIds) {
        await this.$store.dispatch('deleteMaterial', {...this.$route.params, materialId})
      }
    },
    async handleSelectAllItem(val) {
      if (val) {
        this.items.map(i => i.selected = true)
      } else {
        this.items.map(i => i.selected = false)
      }
    },
    initItemList() {
      const selected = this.items.filter(i => i.selected).map(i => i.id)
      this.items = this.parentMaterialList.map(i => {
        return {...i, selected: selected.includes(i.id)}
      })
    },
    disableSelection(e) {
      document.body.style.userSelect = 'none'
    },
    enableSelection(e) {
      document.body.style.userSelect = 'auto'
    },
  },
  watch: {
    parentMaterialList() {
      this.initItemList()
    }
  },
  computed: {
    handleDragItem() {
      return {
        animation: 300,
        disabled: false,
        ghostClass: "ghost-item"
      };
    },
    selectedItem() {
      return this.items.filter(i => i.selected)
    },
    visibleItem() {
      return this.items.filter(i => !i.hidden)
    },
  },
  created() {
    this.initItemList()
  },
}
</script>

<style lang="less">
.ghost-item {
  opacity: 0.1;
  // background: #c8ebfb;
}
</style>

<style lang="less" scoped>
@font-size: 14px;
@font-color: #515a6eb8;
@space-size: 8px;

.root {
  background-color: #fff;

  .head {
    padding: @space-size;
    border: 1px solid #dcdee2;
    background-color: #eee;
    margin-top: -1px;

    .checkbox {
      float: left;
      height: 14px;
      margin-top: -2px; 
    }

    h4 {
      float: left;
      font-size: @font-size - 3;
      line-height: @font-size;

      .sub {
        font-size: @font-size - 5;
        color: #515a6eb8;
      }
    }

    .action {
      display: flex;
      justify-content: flex-end;
      font-size: @font-size - 3;
      text-align: right;

      a {
        margin-left: 6px;
        user-select: none;

        color: #515a6e !important;

        &.blue {
          color: #0f4471 !important;
        }

        &.red {
          color: #fc3c3c!important;
        }

        &.black {
          color: #000 !important;
        }

        i {
          padding-right: 2px;
        }
      }
    }
  }
  .content {
    .item {
      border: 1px solid #dcdee2;
      margin-top: -1px;
      padding: @space-size;
      background-color: #fff;

      .checkbox {
        float: left;
        height: 14px;
        margin-top: -2px; 
      }

      p {
        float: left;
        font-size: @font-size;
        line-height: @font-size;
        vertical-align: middle;
        text-overflow: ellipsis;
        display: inline-block;
        white-space: nowrap;
        font-weight: bold;
        white-space: pre-line;

        &.hide {
          color: #d9d9d9;
        }

        .expired-icon {
          color: #ed4014;
          margin-right: 4px;
          font-size: @font-size + 2;
          vertical-align: middle;
        }
      }

      .action {
         font-size: @font-size - 3px;
         float: right;

         a {
            margin-left: 6px;
            user-select: none;

            i {
              padding-right: 2px;
            }
         }

      }
    }
    .item-sortable {
      cursor: move;
    }
    .item-sortable-locked {
    }
    .new {
      display: inline-block;
      background-color: #f8f8f9;
      width: 100%;
      cursor: pointer;
      border: 1px solid #dcdee2;
      margin-top: -1px;
      font-size: @font-size;
      line-height: @font-size;
      padding: @space-size;
      text-align: center;
      color: @font-color !important;
    }
  }
}
</style>
